import { useDesktopZoomShortcuts } from '@/hooks/desktop';

/** Headless desktop-only listener for browser-style UI zoom shortcuts. */
export const TauriZoomShortcuts = () => {
  useDesktopZoomShortcuts();
  return null;
};
